module.exports = __webpack_public_path__ + "img/foodAndFeed.691798f1.jpg";